import React, { useEffect } from 'react';

function useClickAway({ ref, onClickAway }) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        // Add a small time delay to mousedown event
        // so onclick event will be triggered earier than the onClickAway function
        setTimeout(() => onClickAway(), 150);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}

export default useClickAway;
